import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import Logger from 'src/utils/logger';
import { ClientLog } from 'src/constants/clientLog';
import { getStatusCodeFromError } from 'src/utils/error';
import ErrorView from '../ErrorView';

const domManipulationErrorMessage = "Failed to execute 'removeChild' on 'Node'";

/**
 * Error element for React Router that handles and logs errors while providing a user-friendly error display.
 * This component is designed to be used with React Router's errorElement prop.
 */
const RouterError: React.FC = () => {
  const error = useRouteError() as Error & { status?: number | string };

  useEffect(() => {
    const logContext = {
      errorInfo: error.stack,
      href: window.location.href,
    };

    if (error.message?.includes(domManipulationErrorMessage)) {
      Logger.error(ClientLog.DOMManipulationException, error, logContext);
    } else {
      Logger.error(ClientLog.ComponentUnhandledException, error, logContext);
    }
  }, [error]);

  return (
    <div>
      <ErrorView statusCode={getStatusCodeFromError(error)} />
      {process.env.NODE_ENV !== 'production' && (
        <details style={{ whiteSpace: 'pre-wrap' }}>
          <summary>Error Details</summary>
          <p>{error.message && error.message.toString()}</p>
          <p>{error.stack}</p>
        </details>
      )}
    </div>
  );
};

export default RouterError;
